<script setup>
import { computed } from 'vue';
const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const routeName = computed(() => `${props.row.original.type}_reports_show`);
// T-248: a linha do Bira na lista por time não é um time de verdade e não tem página própria.
// Link que leva a lugar nenhum é pior do que texto.
const semLink = computed(() => Boolean(props.row.original.semLink));
</script>

<template>
  <span v-if="semLink" class="text-n-slate-12">{{ row.original.name }}</span>
  <router-link
    v-else
    :to="{ name: routeName, params: { id: row.original.id } }"
    class="text-n-slate-12 hover:underline"
  >
    {{ row.original.name }}
  </router-link>
</template>
